<template>
  <b-taginput
    :data="filteredRules"
    :placeholder="$t('compSuperadminSettingsActiveRules.label')"
    ref="rulestaginput"
    v-model="buffer"
    :open-on-focus="true"
    @input="$emit('input', buffer)"
    rounded
    icon="caret-right"
    @typing="getFilteredRules"
    autocomplete
  />
</template>

<script>
import { useCoreStore } from '@/stores/core.js'
import { RULES_CLASSES } from '@/models/scenario/RulesFactory.js'

export default {
  name: 'ActiveRules',
  inject: ['$validator'],
  props: {
    value: Array
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      buffer: this.value,
      filteredRules: []
    }
  },
  computed: {
    allRules: function () {
      return Object.keys(RULES_CLASSES)
    }
  },
  methods: {
    getFilteredRules (text) {
      this.filteredRules = this.allRules.filter((name) => {
        return name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = this.value
      },
      deep: true
    }
  },
  mounted () {
    this.buffer = this.coreStore.setting('scenario', 'ACTIVE_RULES').value
    this.filteredRules = this.allRules
  }
}
</script>
